export default __webpack_public_path__ + "static/media/loadingSpinner.58743d94.svg";